import zod from 'zod';

export const SipClientLinkedDeviceFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string(),
  deviceId: zod.number(),
});
